import api from "./API";
import ApiEndpointConstants, {
  url,
  POST_MEASSGE_GROUP_ID,
} from "../constants/ApiEndpointConstants";
import { getConfigFromUrl } from "./FacebookAPI";
import cookie from "react-cookies";
import { postMessage } from "./PostMessageAPI";

/**
 * Send a TikTok event through the backend Events API.
 *
 * @param {string} event Event name, such as ViewContent / AddToCart / AddPaymentInfo / Purchase
 * @param {object} properties Event-specific parameters
 * @param {string} event_id Event ID used for deduplication
 * @param {object} user User matching information
 */
export const getTikTokTrackingIds = () => {
  let ttclid = "";
  let ttp = "";

  // ---------------------------------------------------------
  // Get ttclid from URL
  // ---------------------------------------------------------
  if (typeof window !== "undefined") {
    try {
      const params = new URLSearchParams(window.location.search);

      ttclid = params.get("ttclid") || "";
    } catch (error) {
      console.warn("[TikTok] failed to get ttclid from URL:", error);
    }
  }

  // ---------------------------------------------------------
  // Fallback: get ttclid from cookie
  // ---------------------------------------------------------
  if (!ttclid) {
    try {
      ttclid =
        cookie.load("ttclid", {
          path: "/",
        }) || "";
    } catch (error) {
      console.warn("[TikTok] failed to get ttclid cookie:", error);
    }
  }

  // ---------------------------------------------------------
  // Get _ttp cookie
  // ---------------------------------------------------------
  try {
    ttp =
      cookie.load("_ttp", {
        path: "/",
      }) || "";
  } catch (error) {
    console.warn("[TikTok] failed to get _ttp cookie:", error);
  }

  return {
    ttclid,
    ttp,
  };
};

export const tiktokTrack = async (
  event,
  properties = {},
  event_id = "",
  user = {},
) => {
  try {
    if (!event) {
      console.warn("[TikTok] event is required");
      return null;
    }

    /**
     * Get TikTok configuration.
     */
    const config = await getConfigFromUrl(url);

    if (!config?.tiktok_pixel || !config?.tiktok_token) {
      console.warn("[TikTok] configuration is incomplete");
      return null;
    }

    const { ttclid, ttp } = getTikTokTrackingIds();

    /**
     * User matching information.
     *
     * Do not hash these values on frontend.
     * Backend will normalize and SHA-256 hash them.
     */
    const userData = {
      email: user?.email || "",
      phone: user?.phone || "",
      external_id:
        user?.external_id || user?.id || user?.userId || user?.sessionId || "",
    };

    /**
     * Current page information.
     *
     * url:
     * The page where the TikTok event actually happened.
     *
     * referrer:
     * The page that sent the user here.
     *
     * Example:
     * A site -> B site
     *
     * B page.url      = B
     * B page.referrer = A
     */
    const page = {
      url: window.location.href || "",
      referrer: document.referrer || "",
    };

    const payload = {
      event,
      event_id: event_id || "",
      ttclid,
      ttp,

      properties: {
        ...properties,
      },

      page,

      email: userData.email,
      phone: userData.phone,
      external_id: userData.external_id,

      PixelCode: config.tiktok_pixel,
      TiktokAccessToken: config.tiktok_token,

      test_event_code: "",
    };

    // post内容
    postMessage(
      `[--TikTok - ${event}-发送参数 | event_id : ${event_id}--]:${JSON.stringify(
        payload,
      )}`,
      POST_MEASSGE_GROUP_ID,
    );
    // ---------------------------------------------------------
    // Send event to backend
    // ---------------------------------------------------------
    const res = await api.post(`${ApiEndpointConstants.TIKTOK}`, payload);

    // ---------------------------------------------------------
    // Get backend response
    // ---------------------------------------------------------
    const resData = res?.data?.msg || null;

    console.log(resData);

    // ---------------------------------------------------------
    // Send tracking result to your PostMessage system
    // ---------------------------------------------------------
    postMessage(
      `[--TikTok - ${event} | event_id : ${event_id}--]:${JSON.stringify(
        resData,
      )}`,
      POST_MEASSGE_GROUP_ID,
    );

    return res;
  } catch (error) {
    console.error("[TikTok] track error:", error);
    return null;
  }
};
